import './index.scss';
import { updateFreemiumCounter } from 'utils/freemium';

export function runTextOverlayScript(resource) {
  const resourceInfo = {
    teachers: {
      parent: '.q-question-teacher',
      openedClass: 'teacher-opened'
    }
  };

  $('.q-freemium-text-overlay button')
    .off('click')
    .on('click', event => {
      const $content = $(
        event.currentTarget.closest(resourceInfo[resource].parent)
      );
      $content.addClass(resourceInfo[resource].openedClass);
      $content
        .parent()
        .find('.resource-limit-counter-progress')
        .parent()
        .remove();

      updateFreemiumCounter(resource);
    });
}
